import { useEffect, useState } from 'react';

import { useModalDisplayedEvent } from '@zenbusiness/application-commons-clickstream';

const useModalDisplayTracker = (eventProps) => {
  const [isModalOpened, setIsModalOpened] = useState(false);
  useModalDisplayedEvent({
    open: isModalOpened,
    ...eventProps
  });

  useEffect(() => {
    if (!isModalOpened) {
      setIsModalOpened(true);
    }
  }, [isModalOpened]);
};

export default useModalDisplayTracker;
